import { IViewSettings } from "./ViewSettings"

export const SHOW_READ_NOTIFICATIONS_DEFAULT = false
export const SHOW_DONE_NOTIFICATIONS_DEFAULT = true

export interface IViewSettingsNotifications {
    showReadNotifications?: boolean
    showDoneNotifications?: boolean
}

export default class ViewSettingsNotifications implements IViewSettings {
    showReadNotifications: boolean = SHOW_READ_NOTIFICATIONS_DEFAULT
    showDoneNotifications: boolean = SHOW_DONE_NOTIFICATIONS_DEFAULT

    constructor(data: IViewSettingsNotifications) {
        if (typeof data.showReadNotifications !== "undefined") {
            this.showReadNotifications = data.showReadNotifications
        }
        if (typeof data.showDoneNotifications !== "undefined") {
            this.showDoneNotifications = data.showDoneNotifications
        }
    }

    get isDefault() {
        return this.showReadNotifications === SHOW_READ_NOTIFICATIONS_DEFAULT
            && this.showDoneNotifications === SHOW_DONE_NOTIFICATIONS_DEFAULT
    }
}
